var r = /* @__PURE__ */ ((e) => (e.PRIMARY = "primary", e.SECONDARY = "secondary", e.TERTIARY = "tertiary", e.POSITIVE = "positive", e.NEGATIVE = "negative", e))(r || {});
export {
  r as C
};
